import { Component } from 'san';
import * as _ from 'lodash';
import { Select } from 'santd';


import { IUser } from 'src/models';
import LeanInputCell from '../LeanInputCell/LeanInputCell';

import checkOrgUsersService from 'src/services/checkOrgUsers.service';
import userService from 'src/services/user.service';
import leanService from 'src/services/lean.service';

export default class LeanProjectHandler extends Component {
    static components = {
        'ui-lean-input-cell': LeanInputCell,
        's-select': Select,
        's-select-option': Select.Option,
    };

    static computed = {
        handlerIds() {
            const value = this.data.get('value');
            return value ? [value.user_id] : [];
        }
    };

    constructor(options: any) {
        super(options);
    }

    initData(): {
        focusId: string;    // {{}} 当前focus的组件的id，用来高亮组件
        id: string; // {{}}
        title: string;  // {{}}
        value: IUser;   // {==}
        cachedItems: IUser[];   // {{}} 缓存用户列表（初始化时应传入包含 value 的列表，使用中追加记录选中的用户，以保证Select label正常显示）
        items: IUser[];   // 搜索用户列表
        isRequired: boolean;    // {{}}
        disabledUsers: IUser[];  // {{}} 禁用的用户列表

    } {
        return {
            focusId: null,
            id: null,
            title: '',
            value: null,
            cachedItems: [],
            items: [],
            isRequired: false,
            disabledUsers: []
        };
    }

    inited(): void {
        this.initItems();
    }

    handleSearch(q: string) {
        this.getUsers(q).then(items => {
            this.data.set('items', items);
        });
    }

    handleSelect(userId: string) {
        const items = this.data.get('items');
        const cachedItems = this.data.get('cachedItems');
        const allItems = _.unionBy(_.concat(items, cachedItems), 'user_id');
        const value = this.data.get('value');
        let newValue = null;
        if (userId !== value?.user_id) {
            newValue = _.find(allItems, (item) => userId === item.user_id);
        }
        this.data.set('value', newValue);
        this.fireValueChange(newValue);
    }

    onFocus() {
        this.initItems().then(() => {
            (this.ref('select') as any).setOpenState(true); // santd Select 获取焦点并打开下拉框
            this.fire('focus', this.data.get('id'));
        });
    }

    onBlur() {
        (this.ref('select') as any).setOpenState(false); // santd Select 移除焦点并关闭下拉框
        this.fire('blur', this.data.get('id'));
    }

    onClick() {
        this.onFocus();
    }

    toCheckHandler() {
        checkOrgUsersService.show({
            callback: (users) => {
                this.checkHandler(users);
            }
        });
    }
    checkHandler(checkedUsers: IUser[]) {
        const checkedUser = checkedUsers[0];
        if (!checkedUser) {
            return;
        }
        this.data.set('value', checkedUser);
        this.fireValueChange(checkedUser);

        let cachedItems = this.data.get('cachedItems');
        cachedItems = _.unionBy(_.concat(cachedItems, [checkedUser]), 'user_id');
        this.data.set('cachedItems', cachedItems);

        this.data.set('items', cachedItems);
    }

    fireValueChange(value: IUser) {
        this.fire('value-change', value);
    }

    initItems(): Promise<IUser[]> {
        // 默认取 最近用户列表 + 缓存用户列表
        // 若最近用户列表为空，则取 用户列表 + 缓存用户列表
        let items = this.data.get('items');
        const cachedItems = this.data.get('cachedItems');
        return this.getLatelyUsers().then(latelyUsers => {
            if (latelyUsers.length) {
                return latelyUsers;
            } else {
                return this.getUsers();
            }
        }).then(users => {
            // 将已选中的值放在首个
            const value = this.data.get('value');
            const disabledUsers = this.data.get('disabledUsers');
            const valueArray = value ? [value] : [];
            items = _.unionBy(_.concat(valueArray, users, cachedItems), 'user_id');
            // 将禁用用户移除
            items = _.differenceBy(items, disabledUsers, 'user_id');
            this.data.set('items', items);
            return items;
        });
    }

    /*private*/ getUsers(q?: string): Promise<IUser[]> {
        const params = { page: 1, limit: 10, is_disabled: false };
        if (q) {
            params['q'] = q;
        }
        return userService.getUsers(params);
    }
    /*private*/ getLatelyUsers(): Promise<IUser[]> {
        return userService.getLatelyUsers();
    }

    getPopupContainer() {
        return () => this.el;
    }

    onDropdownVisibleChange(open: boolean) {
        leanService.patchOnDropdownVisibleChange(open, this.el, this.data.get('value'), this.data.get('items'));
    }
}
